// Thin wrapper around fetch for the authenticated /api/* endpoints. Attaches the
// Supabase access token as a Bearer, JSON-encodes bodies, and surfaces the
// server's `error` code on failure so callers can branch (e.g. free_site_exists).

export class ApiError extends Error {
  status: number;
  code: string;
  constructor(status: number, code: string, message?: string) {
    super(message ?? code);
    this.status = status;
    this.code = code;
  }
}

export async function apiFetch<T>(
  path: string,
  token: string,
  init?: { method?: string; body?: unknown },
): Promise<T> {
  const headers: Record<string, string> = {
    Authorization: `Bearer ${token}`,
  };
  let body: string | undefined;
  if (init?.body !== undefined) {
    headers["Content-Type"] = "application/json";
    body = JSON.stringify(init.body);
  }

  const res = await fetch(path, { method: init?.method ?? "GET", headers, body });
  const data = (await res.json().catch(() => ({}))) as Record<string, unknown>;
  if (!res.ok) {
    throw new ApiError(
      res.status,
      typeof data.error === "string" ? data.error : `http_${res.status}`,
      typeof data.message === "string" ? data.message : undefined,
    );
  }
  return data as T;
}
